import React from "react";
import { withWebViewPcpLayout } from "@/layout/withWebViewPcpLayout";

const PcpWebViewSearch = () => {
  return <div>검색 페이지</div>;
};

export default withWebViewPcpLayout(PcpWebViewSearch);
